import * as React from "react";
import type { SVGProps } from "react";

const SvgMiniCart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={20}
    viewBox="0 0 24 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.129 16a2 2 0 1 1 0 4 2 2 0 0 1 0-4m8 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4M.077.615A1 1 0 0 1 1.385.079l3.22 1.495c.3.125.52.388.59.705L7.6 12.999h11.984l2.024-6.002h-1.53q-.008.002-.016.003h-10c-.55 0-1-.45-1-1s.45-1 1-1h5.475v-.004H23a1 1 0 0 1 .947 1.32l-2.698 8.003a1 1 0 0 1-.948.68H6.8a1 1 0 0 1-.976-.78l-1.8-8.001v-.002l-.67-2.996L.615 1.925c-.51-.213-.75-.8-.538-1.31"
    />
  </svg>
);
export default SvgMiniCart;
